// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__3EcTZ","ThumbZoom":"ChapterPlayer_ThumbZoom__3Ap4w"};